import React, { useCallback, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
// import logo from './logo.svg';
import './App.css';
import AdminLayout from './AdminLayout';
import LoginPage from './pages/LoginPage';
import LoginTemplate from './templates/LoginTemplate';

import { AuthProvider } from './AuthContext';
import Unauthorized from './pages/Unauthorized';
import RouteList from './RouteList';
import SalesTemplate from './templates/SalesTemplate/SalesTemplate';
import SalesScreen from './pages/SalesScreen/SalesScreen';

function App() {
  const [headerData, setHeaderData] = useState({ pageName: '' });

  const memoizedSetHeaderData = useCallback((newData) => {
    setHeaderData(newData);
  }, []);

  return (
    <AuthProvider>
      <Routes>
        {/* Main Layout Route */}
        <Route path='/' element={<AdminLayout headerData={headerData} setHeaderData={memoizedSetHeaderData} />}>
          {/* Protected routes under AdminLayout */}
          <Route path='/*' element={<RouteList />} />
        </Route>
        {/* Separate routes outside AdminLayout */}
        <Route path='unauthorized' element={<Unauthorized />} />
        <Route path='login' element={<LoginTemplate />}>
          <Route index element={<LoginPage />} />
        </Route>
        <Route path='sales' element={<SalesTemplate />}>
          <Route index element={<SalesScreen />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default React.memo(App);
